<div 
    class="profile-box info-box equity" 
    fxLayout="column"
    *ngIf="rows.length > 0 || rowsYear.length > 0"
>
    <div *ngIf="rowsYear.length > 0">
        <header class="accent">
            <div class="title">Variação Patrimonial Anual</div>
        </header>
    
        <ngx-datatable 
            #tableYear
            class='material striped' 
            [loadingIndicator]="loadingList"
            [columns]="columns" 
            [columnMode]="'force'" 
            [headerHeight]="50"                       
            [footerHeight]="50" 
            [rowHeight]="'auto'" 
            [rows]='rowsYear'
            [limit]="params.per_page"
            (activate)="onClickEquityVariationYear($event)"  
        >       
    
            <ngx-datatable-column name="Ano" prop="year" [sortable]="false" [width]="80">
                <ng-template let-rowIndex="rowIndex" let-year="value" ngx-datatable-cell-template>
                    Ano {{ year }}
                </ng-template>
            </ngx-datatable-column> 
        
            <ngx-datatable-column name="Patrimonio Inicial" prop="ativo" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span>
                        R$ {{ row.totalFirstMonth | number : '1.2-2' }}
                    </span>
                </ng-template>
            </ngx-datatable-column>
                                            
            <ngx-datatable-column name="Aporte/Retiradas" prop="contribuitionWithdrawal" [sortable]="false" [width]="180">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span>R$ {{ row.contribuitionWithdrawal | number : '1.2-2' }} </span>
                    <span>                        
                        <button 
                            style="width: 20px;"
                            mat-icon-button 
                            matTooltip="Informação" 
                            (click)="onClickModalInfomation(row)"
                        >
                            <mat-icon class="s-16">info</mat-icon>
                        </button>
                    </span>
                </ng-template>
            </ngx-datatable-column>
        
            <ngx-datatable-column name="Patrimonio Final" prop="tipo_ativo" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span>
                        R$ {{ row.totalLastMonth | number : '1.2-2' }}
                    </span>
                </ng-template>
            </ngx-datatable-column>
        
            <ngx-datatable-column name="Variação (R$)" prop="qtd_executado" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span
                        [ngClass]="{
                            'negativo': row.equityVariation < 0, 
                            'positivo': row.equityVariation > 0
                        }"
                    >
                        R$ {{ row.equityVariation | number : '1.2-2' }}
                    </span>
                    
                </ng-template>
            </ngx-datatable-column>
        
            <ngx-datatable-column name="Variação (%)" prop="preco_executado" [width]="100" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span
                        [ngClass]="{
                            'negativo': row.equityVariation < 0, 
                            'positivo': row.equityVariation > 0
                        }"
                    >            
                        {{ row.percentVariation | number : '1.2-2' }} %
                    </span>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    </div>

    <div *ngIf="rows.length > 0">

        <header class="accent" style="margin-top: 10px;">
            <div class="title">Variação Patrimonial Mensal</div>
        </header>
    
        <ngx-datatable 
            #table 
            class='material striped' 
            [loadingIndicator]="loadingList"
            [columns]="columns" 
            [columnMode]="'force'" 
            [headerHeight]="50"                       
            [footerHeight]="50" 
            [rowHeight]="'auto'" 
            [rows]='rows'
            [limit]="params.per_page"
        >       
    
            <ngx-datatable-column name="Mês" prop="date" [sortable]="false" [width]="100">
                <ng-template let-rowIndex="rowIndex" let-date="value" ngx-datatable-cell-template>
                    {{ date | date:'MM/yyyy'}}
                </ng-template>
            </ngx-datatable-column> 
    
            <ngx-datatable-column name="Patrimonio Inicial" prop="ativo" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span>
                        R$ {{ row.totalLastMonth | number : '1.2-2' }}
                    </span>
                </ng-template>
            </ngx-datatable-column>
                                            
            <ngx-datatable-column name="Aporte/Retiradas" prop="contribuitionWithdrawal" [sortable]="false" [width]="160">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span>
                        R$ {{ row.contribuitionWithdrawal | number : '1.2-2' }}
                    </span>
                    <span>
                        <button 
                            style="width: 20px;"
                            mat-icon-button 
                            matTooltip="Ver composição do valor" 
                            (click)="onClickModalInfomation(row)"
                        >
                            <mat-icon class="s-16">info</mat-icon>
                        </button>
                    </span>
                </ng-template>
            </ngx-datatable-column>
    
            <ngx-datatable-column name="Patrimonio Final" prop="tipo_ativo" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span>
                        R$ {{ row.totalMonth | number : '1.2-2' }}
                    </span>
                </ng-template>
            </ngx-datatable-column>
    
            <ngx-datatable-column name="Variação (R$)" prop="qtd_executado" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span
                        matTooltip="(Patrimonio Final - Patrimonio Inicial) - Aportes/Retiradas"
                        [ngClass]="{
                            'negativo': row.equityVariation < 0, 
                            'positivo': row.equityVariation > 0
                        }"
                    >
                        R$ {{ row.equityVariation | number : '1.2-2' }}
                    </span>
                    
                </ng-template>
            </ngx-datatable-column>
    
            <ngx-datatable-column name="Variação (%)" prop="preco_executado" [width]="100" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    <span
                        [ngClass]="{
                            'negativo': row.equityVariation < 0, 
                            'positivo': row.equityVariation > 0
                        }"
                    >            
                        {{ row.percentVariation | number : '1.2-2' }} %
                    </span>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    </div>
</div>

